import { useMemo } from 'react';

import { usePalletsTypes } from 'constants/palletTypes';
import { GroupedLostDamagedPalletItems, OrderDetails } from 'interfaces';
import { getPalletTypes } from 'utils/functions';
import { sortOptions } from 'utils/functions/sortOptions';

type OrderDetailsProps = {
   order: OrderDetails;
   groupedLostDamagedPalletItems?: GroupedLostDamagedPalletItems | null;
   edit?: boolean;
};

export const useRegularOrderDetails = ({
   order,
   groupedLostDamagedPalletItems,
   edit,
}: OrderDetailsProps) => {
   const { PALLET_TYPE_LABELS } = usePalletsTypes();

   const availablePalletTypesToSend = useMemo(() => {
      if (order.mode === 'ADDED_TO_NEXT_ORDER') {
         return [];
      } else if (groupedLostDamagedPalletItems) {
         const palletTypes = groupedLostDamagedPalletItems.damaged.map(
            itemToSend => itemToSend.palletType,
         );
         return sortOptions(palletTypes);
      } else if (edit) {
         return getPalletTypes(order.pallets, PALLET_TYPE_LABELS);
      } else {
         return getPalletTypes(order.remainingPalletsToBeSend, PALLET_TYPE_LABELS);
      }
   }, [
      order.mode,
      order.pallets,
      order.remainingPalletsToBeSend,
      groupedLostDamagedPalletItems,
      edit,
      PALLET_TYPE_LABELS,
   ]);

   const availablePalletTypesToReport = useMemo(
      () =>
         order.mode === 'ADDED_TO_NEXT_ORDER'
            ? []
            : getPalletTypes(order.remainingPalletsToBeSend, PALLET_TYPE_LABELS),
      [PALLET_TYPE_LABELS, order.mode, order.remainingPalletsToBeSend],
   );

   return {
      availablePalletTypesToSend,
      availablePalletTypesToReport,
   };
};
